import { Plus, Trash2 } from "lucide-react";
import { Switch } from "../ui/switch";
import { inputCls } from "./adminConstants";

export function SettingsView({ ctx }) {
  const {
    maintenanceMode, toggleMaintenance, ageGateEnabled, toggleAgeGate, contact, setContact, socials, setSocials,
    promo, setPromo, shipping, setShipping, saveFooterSettings, savingSettings,
    footerInfo, setFooterInfo, legal, setLegal,
    minOrderQty, setMinOrderQty,
    security, setSecurity, saveSecurity, savingSecurity,
    newPassword, setNewPassword, confirmPassword, setConfirmPassword, changePassword, changingPw,
    currentPassword, setCurrentPassword,
  } = ctx;

  const legalFields = [
    { key: "legal_purchase", label: "Condizioni di acquisto", page: "/condizioni-acquisto" },
    { key: "legal_conditions", label: "Condizioni legali", page: "/condizioni-legali" },
    { key: "legal_delivery", label: "Condizioni di consegna", page: "/condizioni-consegna" },
    { key: "legal_refund", label: "Politica di rimborso", page: "/politica-rimborso" },
  ];

  return (
    <div className="p-6 lg:p-12 max-w-2xl" data-testid="settings-view">
      <div className="flex items-center justify-between border border-white/15 bg-[#141A14] px-6 py-5 mb-10" data-testid="maintenance-bar">
        <div>
          <p className="font-serif-display text-2xl text-[#E8E2D2]">Sito in manutenzione</p>
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mt-1">
            Se attivo, i visitatori vedono la pagina di manutenzione (l'admin resta accessibile)
          </p>
        </div>
        <Switch checked={maintenanceMode} onCheckedChange={toggleMaintenance} data-testid="maintenance-switch" />
      </div>

      <div className="flex items-center justify-between border border-white/15 bg-[#141A14] px-6 py-5 mb-10" data-testid="agegate-bar">
        <div>
          <p className="font-serif-display text-2xl text-[#E8E2D2]">Verifica età (18+)</p>
          <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mt-1">
            Se attiva, i visitatori devono confermare di essere maggiorenni prima di entrare
          </p>
        </div>
        <Switch checked={ageGateEnabled} onCheckedChange={toggleAgeGate} data-testid="agegate-switch" />
      </div>

      <h2 className="font-serif-display text-3xl text-[#E8E2D2] mb-2">Contatti footer</h2>
      <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mb-6">Modifica i dati mostrati nel footer del sito</p>
      <div className="space-y-3 mb-10">
        <div>
          <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Indirizzo</label>
          <input value={contact.address} onChange={(e) => setContact({ ...contact, address: e.target.value })}
            className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="settings-address" />
        </div>
        <div>
          <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Email</label>
          <input value={contact.email} onChange={(e) => setContact({ ...contact, email: e.target.value })}
            className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="settings-email" />
        </div>
        <div>
          <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Telefono</label>
          <input value={contact.phone} onChange={(e) => setContact({ ...contact, phone: e.target.value })}
            className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="settings-phone" />
        </div>
      </div>

      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif-display text-3xl text-[#E8E2D2]">Social</h2>
        <button
          onClick={() => setSocials([...socials, { label: "", url: "" }])}
          className="flex items-center gap-2 border border-white/20 px-4 py-2 font-mono-accent text-[11px] uppercase tracking-widest hover:border-[#D47738] hover:text-[#D47738] transition-colors"
          data-testid="add-social-btn"
        >
          <Plus className="w-3.5 h-3.5" /> Aggiungi
        </button>
      </div>
      <div className="space-y-3 mb-10" data-testid="socials-editor">
        {socials.map((s, i) => (
          <div key={i} className="flex gap-2 items-center" data-testid={`social-row-${i}`}>
            <input placeholder="Nome (es. Instagram)" value={s.label}
              onChange={(e) => setSocials(socials.map((x, xi) => xi === i ? { ...x, label: e.target.value } : x))}
              className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid={`social-label-${i}`} />
            <input placeholder="URL" value={s.url}
              onChange={(e) => setSocials(socials.map((x, xi) => xi === i ? { ...x, url: e.target.value } : x))}
              className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid={`social-url-${i}`} />
            <button onClick={() => setSocials(socials.filter((_, xi) => xi !== i))}
              className="p-3 border border-white/20 hover:border-[#9E3C3C] hover:text-[#9E3C3C] transition-colors" data-testid={`social-remove-${i}`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10 pt-10 mb-10" data-testid="promo-editor">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-serif-display text-3xl text-[#E8E2D2]">Banner Promo</h2>
          <Switch
            checked={!!promo.enabled}
            onCheckedChange={(v) => setPromo({ ...promo, enabled: v })}
            className="data-[state=checked]:bg-[#D47738]"
            data-testid="promo-enabled-switch"
          />
        </div>
        <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mb-6">
          Fascia mostrata in cima al sito con l'offerta o il codice sconto del momento. Il link è opzionale.
        </p>
        <div className="space-y-4">
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Testo del banner</label>
            <input value={promo.text} onChange={(e) => setPromo({ ...promo, text: e.target.value })}
              placeholder="Es. Spedizione gratis con il codice BENVENUTO10!"
              className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="promo-text-input" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Etichetta link (opzionale)</label>
              <input value={promo.link_label} onChange={(e) => setPromo({ ...promo, link_label: e.target.value })}
                placeholder="Es. Scopri di più"
                className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="promo-link-label-input" />
            </div>
            <div>
              <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">URL link (opzionale)</label>
              <input value={promo.link_url} onChange={(e) => setPromo({ ...promo, link_url: e.target.value })}
                placeholder="Es. #catalogo oppure https://..."
                className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="promo-link-url-input" />
            </div>
          </div>
          {promo.enabled && promo.text && (
            <div className="bg-[#D47738] text-[#0D110D] px-4 py-2 text-center font-mono-accent text-[11px] uppercase tracking-[0.15em] font-semibold" data-testid="promo-preview">
              {promo.text}{promo.link_label && promo.link_url ? ` — ${promo.link_label}` : ""}
            </div>
          )}
        </div>
      </div>

      <div className="border-t border-white/10 pt-10 mb-10" data-testid="shipping-editor">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-serif-display text-3xl text-[#E8E2D2]">Spedizione a scaglioni</h2>
          <Switch
            checked={!!shipping.enabled}
            onCheckedChange={(v) => setShipping({ ...shipping, enabled: v })}
            className="data-[state=checked]:bg-[#D47738]"
            data-testid="shipping-enabled-switch"
          />
        </div>
        <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mb-6">
          Costo calcolato in base al subtotale del carrello. Se disattivata, spedizione sempre gratuita.
        </p>

        <div className="mb-6">
          <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Ordine minimo (numero di lattine)</label>
          <input type="number" min="1" step="1" value={minOrderQty}
            onChange={(e) => setMinOrderQty(e.target.value)}
            className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="min-order-qty-input" />
          <p className="font-mono-accent text-[9px] uppercase tracking-wider text-[#E8E2D2]/30 mt-1">
            La confezione minima deve contenere almeno questo numero di lattine (mostrato nello shop e bloccato al checkout).
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-6">
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Spedizione gratis oltre € (0 = mai)</label>
            <input type="number" step="any" value={shipping.free_over ?? 0}
              onChange={(e) => setShipping({ ...shipping, free_over: e.target.value })}
              className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="shipping-free-over" />
          </div>
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Costo oltre l'ultima fascia €</label>
            <input type="number" step="any" value={shipping.default_cost ?? 0}
              onChange={(e) => setShipping({ ...shipping, default_cost: e.target.value })}
              className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="shipping-default-cost" />
          </div>
        </div>

        <div className="flex items-center justify-between mb-3">
          <p className="font-mono-accent text-[11px] uppercase tracking-widest text-[#E8E2D2]/60">Fasce (subtotale fino a → costo)</p>
          <button
            onClick={() => setShipping({ ...shipping, tiers: [...(shipping.tiers || []), { up_to: "", cost: "" }] })}
            className="flex items-center gap-2 border border-white/20 px-4 py-2 font-mono-accent text-[11px] uppercase tracking-widest hover:border-[#D47738] hover:text-[#D47738] transition-colors"
            data-testid="add-tier-btn"
          >
            <Plus className="w-3.5 h-3.5" /> Fascia
          </button>
        </div>
        <div className="space-y-3">
          {(shipping.tiers || []).map((t, i) => (
            <div key={i} className="flex gap-2 items-center" data-testid={`tier-row-${i}`}>
              <div className="flex items-center gap-2 flex-1">
                <span className="font-mono-accent text-[10px] uppercase text-[#E8E2D2]/40">fino a €</span>
                <input type="number" step="any" placeholder="30" value={t.up_to}
                  onChange={(e) => setShipping({ ...shipping, tiers: shipping.tiers.map((x, xi) => xi === i ? { ...x, up_to: e.target.value } : x) })}
                  className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid={`tier-upto-${i}`} />
              </div>
              <div className="flex items-center gap-2 flex-1">
                <span className="font-mono-accent text-[10px] uppercase text-[#E8E2D2]/40">costo €</span>
                <input type="number" step="any" placeholder="6.90" value={t.cost}
                  onChange={(e) => setShipping({ ...shipping, tiers: shipping.tiers.map((x, xi) => xi === i ? { ...x, cost: e.target.value } : x) })}
                  className="flex-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid={`tier-cost-${i}`} />
              </div>
              <button onClick={() => setShipping({ ...shipping, tiers: shipping.tiers.filter((_, xi) => xi !== i) })}
                className="p-3 border border-white/20 hover:border-[#9E3C3C] hover:text-[#9E3C3C] transition-colors" data-testid={`tier-remove-${i}`}>
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
          {(shipping.tiers || []).length === 0 && (
            <p className="font-mono-accent text-[10px] text-[#E8E2D2]/30 uppercase tracking-wider">Nessuna fascia: verrà applicato sempre il costo oltre l'ultima fascia.</p>
          )}
        </div>
      </div>

      <div className="border-t border-white/10 pt-10 mb-10" data-testid="legal-footer-editor">
        <h2 className="font-serif-display text-3xl text-[#E8E2D2] mb-2">Legale &amp; Footer</h2>
        <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mb-6">
          Partita IVA, testo del footer e testi delle pagine legali. Scrivi le sezioni come "1. TITOLO" su una riga, poi il testo. Separa i blocchi con una riga vuota.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Partita IVA</label>
            <input value={footerInfo.p_iva} onChange={(e) => setFooterInfo({ ...footerInfo, p_iva: e.target.value })}
              className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="settings-piva" />
          </div>
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Testo footer (descrizione)</label>
            <input value={footerInfo.footer_text} onChange={(e) => setFooterInfo({ ...footerInfo, footer_text: e.target.value })}
              className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent focus:border-[#D47738] focus:outline-none" data-testid="settings-footer-text" />
          </div>
        </div>

        <div className="space-y-6">
          {legalFields.map((f) => (
            <div key={f.key}>
              <div className="flex items-center justify-between mb-1">
                <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">{f.label}</label>
                <a href={f.page} target="_blank" rel="noreferrer"
                  className="font-mono-accent text-[10px] uppercase tracking-widest text-[#D47738]/70 hover:text-[#D47738] transition-colors"
                  data-testid={`legal-view-${f.key}`}>Anteprima ↗</a>
              </div>
              <textarea rows={8} value={legal[f.key]} onChange={(e) => setLegal({ ...legal, [f.key]: e.target.value })}
                className="w-full mt-1 bg-transparent border border-white/20 px-4 py-3 text-sm text-[#E8E2D2] font-mono-accent leading-relaxed focus:border-[#D47738] focus:outline-none resize-y"
                data-testid={`legal-textarea-${f.key}`} />
            </div>
          ))}
        </div>
      </div>

      <button
        onClick={saveFooterSettings}
        disabled={savingSettings}
        className="bg-[#D47738] text-[#0D110D] px-8 py-4 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors disabled:opacity-50"
        data-testid="save-settings-btn"
      >
        {savingSettings ? "Salvataggio..." : "Salva impostazioni"}
      </button>

      <div className="border-t border-white/10 pt-10 mt-12" data-testid="security-section">
        <h2 className="font-serif-display text-3xl text-[#E8E2D2] mb-2">Sicurezza</h2>
        <p className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/40 mb-6">
          Il link di recupero password viene inviato SOLO all'email di amministrazione{security.admin_email ? ` (${security.admin_email})` : ""}{security.recovery_email_alt ? ` e a ${security.recovery_email_alt}` : ""}.
        </p>

        <div className={`mb-6 inline-block font-mono-accent text-[10px] uppercase tracking-widest px-3 py-2 border ${security.password_expired ? "bg-[#9E3C3C]/30 text-[#9E3C3C] border-[#9E3C3C]/50" : "bg-[#4A6E4A]/20 text-[#4A6E4A] border-[#4A6E4A]/40"}`} data-testid="password-expiry-status">
          {security.password_expired
            ? "Password SCADUTA — cambiala subito"
            : `Password valida ancora ${security.days_until_expiry} giorni`}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Email di recupero alternativa</label>
            <input type="email" value={security.recovery_email_alt || ""}
              onChange={(e) => setSecurity({ ...security, recovery_email_alt: e.target.value })}
              placeholder="es. titolare@gmail.com"
              className={inputCls + " mt-1"} data-testid="recovery-email-input" />
          </div>
          <div>
            <label className="font-mono-accent text-[10px] uppercase tracking-widest text-[#E8E2D2]/50">Scadenza password (giorni)</label>
            <input type="number" min="1" value={security.max_age_days ?? 90}
              onChange={(e) => setSecurity({ ...security, max_age_days: e.target.value })}
              className={inputCls + " mt-1"} data-testid="max-age-input" />
          </div>
        </div>
        <button onClick={saveSecurity} disabled={savingSecurity}
          className="border border-white/20 px-6 py-3 font-mono-accent text-xs uppercase tracking-[0.2em] text-[#E8E2D2] hover:border-[#D47738] hover:text-[#D47738] transition-colors disabled:opacity-50 mb-10"
          data-testid="save-security-btn">
          {savingSecurity ? "Salvataggio..." : "Salva sicurezza"}
        </button>

        <h3 className="font-mono-accent text-[11px] uppercase tracking-widest text-[#E8E2D2]/70 mb-4 border-t border-white/10 pt-8">Cambia password</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
          <input type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)}
            placeholder="Password attuale" className={inputCls + " md:col-span-2"} data-testid="current-password-input" autoComplete="current-password" />
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Nuova password (min 8)" className={inputCls} data-testid="new-password-input" autoComplete="new-password" />
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Conferma password" className={inputCls} data-testid="confirm-password-input" autoComplete="new-password" />
        </div>
        <button onClick={changePassword} disabled={changingPw}
          className="mt-4 bg-[#D47738] text-[#0D110D] px-6 py-3 font-mono-accent text-xs uppercase tracking-[0.2em] hover:bg-[#E8E2D2] transition-colors disabled:opacity-50"
          data-testid="change-password-btn">
          {changingPw ? "Aggiornamento..." : "Aggiorna password"}
        </button>
      </div>
    </div>
  );
}
